<template>
    <div>
        <!-- <v-dialog v-model="wrapper" class="v-dialog" id="loadingwrapper" style="width: 250px; height: 250px;" >
            <div v-if="wrapper" id="loadingtext">Processando...</div>
            <div v-if="wrapper" id="loadingcontent"></div>
        </v-dialog> -->
        <!-- <div id="loadingwrapper"> -->
        <!-- <div v-if="wrapper" id="loadingwrapper">
            <div v-if="wrapper" id="loadingtext">Processando</div>
            <div v-if="wrapper" id="loadingcontent"></div>
        </div> -->

        <!-- Splash qdo processando o arquivo -->
        <ScreenSplash :wrapper="wrapper"/>

        <!-- Início principal -->
        <v-card>
            <v-toolbar
                flat
            >
                <v-icon>
                    fas fa-file-invoice
                </v-icon>
                <v-toolbar-title
                    class="pl-4"
                >
                    Importação de objetos (Extrato ou CSV)
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-app-bar-nav-icon @click="fechar">
                    <v-icon>fas fa-times</v-icon>
                </v-app-bar-nav-icon>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text>
                <v-row>
                    <v-col class="px-6 py-6" >
                        <input type="file" @change="selectFile($event)" @click="(carrega = 0)" ref="arquivo">
                    </v-col>
                    <!-- <v-col>
                        <div :style="{visibility: loading ? 'visible' : 'hidden'}">
                            <v-progress-circular
                                :rotate="-90"
                                :size="100"
                                :width="15"
                                :value="carrega"
                                color="primary"
                            >
                                {{ carrega }}
                            </v-progress-circular>
                        </div>
                    </v-col> -->
                </v-row>
                <v-row>
                    <v-col
                        cols="12"
                        md="12"
                    >
                    <v-textarea
                        outlined
                        filled
                        v-model="message"
                        :label="label"
                        :readonly="true"
                        rows="12"
                        cols="148"
                    ></v-textarea>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
        <!-- Fim principal -->
    </div>
</template>

<script>
import { baseApiUrl, showError, showSuccess } from '@/global'
import axios from 'axios'
import ScreenSplash from '../components/ScreenSplash.vue'

export default {
    name: 'ImportacaoObjetos',
    components: {
        ScreenSplash
    },
    data: () => ({
        arquivo: '',
        loading: false,
        // showScreen: false,
        wrapper: false,
        label: 'Nenhum arquivo processado.',
        message: [],
        carrega: 0,
        return: {
            carrega: 0,
        }
    }),
    methods: {
        fechar () {
            this.$router.push('/')
        },

        async SendFile(url, data) {
            var config = {
                onUploadProgress: function(progressEvent) {
                    this.carrega = Math.round( (progressEvent.loaded * 100) / progressEvent.total );
                }.bind(this)
            };
            await axios
                .post(url, data, config)
                .then(res => {
                    if (res.data.retorno) {
                        this.message = "\n" + res.data.mensagem;
                        this.message += "\n" + res.data.data;
                        showSuccess(res.data.mensagem)
                    } else {
                        this.message = "\nError\n"
                        this.message += res.data.mensagem;
                        showError(res.data.mensagem)
                    }
                })
                .catch(error => {
                    console.log("Error ", error)
                    showError(error)
                })
                .finally(() => {
                    this.$refs.arquivo.value=null;
                    this.loading = false;
                    this.wrapper = false;
                })
        },

        selectFile(event) {
            this.message = '';
            this.carrega = 0;
            let file = event.target.files[0]
            this.label = "Arquivo processado:- " + file.name
            const data = new FormData()
            data.append('arquivo', file)
            let url = `${baseApiUrl}/uploads`
            this.loading = false;
            this.carrega = 0;
            this.wrapper = true;

            this.SendFile(url, data )

            // axios.post(url, data, config)
            // .then(res => {
            //     if (res.data.retorno) {
            //         this.message = "\n" + res.data.mensagem;
            //         this.message += "\n" + res.data.data;
            //         // console.log(res.data.data)
            //         showSuccess(res.data.mensagem)
            //     } else {
            //         this.message = "\nError\n"
            //         this.message += res.data.mensagem;
            //         showError(res.data.mensagem)
            //     }
            // })
            // .catch(error => {
            //     console.log("Error ", error)
            //     showError(error)
            // })
            // .finally(() => {
            //     this.$refs.arquivo.value=null;
            //     this.loading = false;
            //     this.wrapper = false;
            // })
                // }

            // try{
            //     let res =  await axios.post(url, data, config)
            //     if (res.data.retorno) {
            //         this.message = "\n" + res.data.mensagem;
            //         this.message += "\n" + res.data.data;
            //         // console.log(res.data.data)
            //         showSuccess(res.data.mensagem)
            //     } else {
            //         this.message = "\nError\n"
            //         this.message += res.data.mensagem;
            //         showError(res.data.mensagem)
            //     }
            // }catch(error) {
            //     console.log("Error ", error)
            //     showError(error)
            // }
            // finally {
            //     this.$refs.arquivo.value=null;
            //     this.loading = false;
            //     this.wrapper = false;
            // };
        }
    }
}
</script>


<style lang="scss" scoped>
//   .v-dialog {
//     width: 250px;
//     height: 250px;
//   }

//   #loadingwrapper {
//     position: fixed;
//     width: 100%;
//     height: 100%;
//     left: 0;
//     top: 0;
//     font-family: Arial, Helvetica, sans-serif;
//     background: rgba(0,0,0,0.8);
//     z-index: 99999;
//     opacity:0,46;
//     -webkit-transition: opacity 400ms ease-in;
//     -moz-transition: opacity 400ms ease-in;
//     transition: opacity 400ms ease-in;
//     pointer-events: none;

//   }

//   #loadingtext {
//     display: block;
//     position: absolute;
//     top: 49%;
//     left: 49%;
//     color: rgb(20, 121, 60);
//     width: 100px;
//     height: 30px;
//     margin: -7px 0 0 -45px;
//     text-align: center;
//     font-family: 'PT Sans Narrow', sans-serif;
//     font-size: 20px;
//   }

//   #loadingcontent {
//     display: block;
//     position: relative;
//     left: 50%;
//     top: 50%;
//     width: 170px;
//     height: 170px;
//     margin: -85px 0 0 -85px;
//     border: 3px solid #F00;
//   }

//   #loadingcontent {
//     border: 3px solid transparent;
//     border-top-color: rgb(121, 61, 185);
//     border-bottom-color: rgb(121, 61, 185);
//     border-radius: 50%;
//     -webkit-animation: loader 2s linear infinite;
//     -moz-animation: loader 2s linear infinite;
//     -o-animation: loader 2s linear infinite;
//     animation: loader 2s linear infinite;
//   }

//   @keyframes loader {
//     0% {
//       -webkit-transform: rotate(0deg);
//       -ms-transform: rotate(0deg);
//       transform: rotate(0deg);
//     }

//     100% {
//       -webkit-transform: rotate(360deg);
//       -ms-transform: rotate(360deg);
//       transform: rotate(360deg);
//     }
//   }
</style>